const ROOT_SELECTOR = '[form-select]';
const OPEN_ATTR = 'data-form-select-open';

function setDropdownOpen(root, open) {
    const dropdown = root.querySelector('[form-select-dropdown]');
    const toggle = root.querySelector('[form-select-toggle]');

    if (!dropdown) {
        return;
    }

    if (open) {
        root.setAttribute(OPEN_ATTR, '');
        dropdown.classList.remove('max-h-0', 'pointer-events-none');
        dropdown.classList.add('max-h-[min(16rem,50vh)]', 'overflow-y-auto', 'pointer-events-auto');
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        }
        return;
    }

    root.removeAttribute(OPEN_ATTR);
    dropdown.classList.add('max-h-0', 'pointer-events-none');
    dropdown.classList.remove('max-h-[min(16rem,50vh)]', 'overflow-y-auto', 'pointer-events-auto');
    if (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
    }
}

function closeAllFormSelects(exceptRoot = null) {
    document.querySelectorAll(ROOT_SELECTOR).forEach(root => {
        if (root !== exceptRoot) {
            setDropdownOpen(root, false);
        }
    });
}

function filterFormSelectItems(root, query) {
    const normalized = query.trim().toLowerCase();

    root.querySelectorAll('[form-select-item]').forEach(item => {
        const label = (item.getAttribute('form-select-name') || item.textContent || '').trim().toLowerCase();
        item.classList.toggle('hidden', normalized !== '' && !label.includes(normalized));
    });
}

function selectFormSelectItem(root, item) {
    const select = root.querySelector('[form-select-select]');
    const textEl = root.querySelector('[form-select-text]');
    const emailHidden = root.querySelector('[email-from-select]');

    if (!select || !item) {
        return;
    }

    const value = item.getAttribute('form-select-item') || '';
    const label = item.getAttribute('form-select-name') || item.textContent || '';
    const email = item.getAttribute('form-select-email') || '';

    select.value = value;
    select.dispatchEvent(new Event('change', { bubbles: true }));

    if (textEl) {
        textEl.textContent = label.trim();
    }

    if (emailHidden) {
        emailHidden.value = email;
    }

    setDropdownOpen(root, false);
}

function initFormSelect(root) {
    if (root.dataset.formSelectInit === '1') {
        return;
    }

    root.dataset.formSelectInit = '1';

    const toggle = root.querySelector('[form-select-toggle]');
    const search = root.querySelector('[form-select-search]');

    if (toggle) {
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('tabindex', '0');
        toggle.setAttribute('aria-expanded', 'false');
    }

    toggle?.addEventListener('click', event => {
        event.stopPropagation();
        const isOpen = root.hasAttribute(OPEN_ATTR);
        if (isOpen) {
            setDropdownOpen(root, false);
            return;
        }
        closeAllFormSelects(root);
        setDropdownOpen(root, true);
        if (search) {
            search.value = '';
            filterFormSelectItems(root, '');
            search.focus();
        }
    });

    toggle?.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle.click();
        }
    });

    root.querySelectorAll('[form-select-item]').forEach(item => {
        item.addEventListener('click', event => {
            event.stopPropagation();
            selectFormSelectItem(root, item);
        });
    });

    search?.addEventListener('input', () => {
        filterFormSelectItems(root, search.value);
    });

    search?.addEventListener('click', event => {
        event.stopPropagation();
    });
}

export function initFormSelects() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initFormSelect);

    document.addEventListener('click', () => {
        closeAllFormSelects();
    });

    document.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
            closeAllFormSelects();
        }
    });
}
